export var ssrFeatureFlags = function ssrFeatureFlags(ssr) {
  if (!(ssr !== null && ssr !== void 0 && ssr.getFeatureFlags)) {
    return null;
  }
  try {
    var featureFlags = ssr.getFeatureFlags();
    if (featureFlags) {
      return {
        'ssr:featureFlags': featureFlags
      };
    }
  } catch (e) {}
  return null;
};